<template>
  <div class="h-100 p-r">
    <div ref="three" class="h-100"></div>
    <dv-border-box-10 class="text-box" :color="['#7acaec', '#7acaec']">
      <div class="dy">
        <p class="p-bar">
          <span>类型:</span>
          <span> 干式变压器 </span>
        </p>
        <p class="p-bar">
          <span>材质:</span>
          <span> 硅钢、铜(线圈) </span>
        </p>
        <p class="p-bar">
          <span>外形尺寸:</span>
          <span> 103－112－99(mm) </span>
        </p>
      </div>
    </dv-border-box-10>
  </div>
</template>

<script>
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

export default {
  methods: {
    init() {
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(
        75,
        window.innerWidth / window.innerHeight,
        0.1,
        1000
      );
      const renderer = new THREE.WebGLRenderer({
        alpha: true,
      });
      renderer.setSize(
        this.$refs.three.clientWidth,
        this.$refs.three.clientHeight
      );
      this.$refs.three.appendChild(renderer.domElement);

      const gltfLoader = new GLTFLoader();
      let model;
      gltfLoader.load("static/room.glb", (gltf) => {
        model = gltf.scene;
        scene.add(gltf.scene);
      });

      // 控制器
      const controls = new OrbitControls(camera, renderer.domElement);
      controls.enablePan = false; //滑动
      controls.enableDamping = true;
      controls.dampingFactor = 0.05;
      controls.screenSpacePanning = false;
      controls.autoRotate = true; //场景自动旋转
      controls.autoRotateSpeed = 1; //旋转的速度
      controls.target.set(0, 0, 0);

      // 光源设置
      // 半球光
      const hemiLight = new THREE.HemisphereLight();
      hemiLight.intensity = 0.3;
      scene.add(hemiLight);
      // 环境光
      const ambientLight = new THREE.AmbientLight(0xffffff, 1);
      scene.add(ambientLight);
      // 平行光
      const light = new THREE.DirectionalLight(0xffffff, 0.3);
      light.position.set(-10, -1, 100);
      scene.add(light);

      camera.position.z = 100;

      function animate() {
        requestAnimationFrame(animate);

        if (model) {
          model.rotation.x += 0.001;
          model.rotation.y += 0.001;
        }

        renderer.render(scene, camera);
      }

      animate();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.p-r {
  position: relative;
}
.text-box {
  position: absolute;
  top: 20px;
  right: 20px;
  height: unset;
  width: unset;
}

.p-bar {
  color: white;
  text-shadow: 0 0 10px #28f8ff;
}
</style>
